import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";

const ContactFormpage = () => {
  const form = useRef();
  const [isSending, setIsSending] = useState(false);
  const navigate = useNavigate();

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsSending(true);

    // Form data ko JS object banate hain
    const formData = new FormData(form.current);
    const jsonData = Object.fromEntries(formData.entries());
    console.log("Form Data going to PHP:", jsonData); // Debug

    try {
      // 1. EmailJS se bhejna
      await emailjs.sendForm(
        "service_r1t9oq8",
        "template_fdzsqka",
        form.current,
        "o0-qZnllB8LkS2pa0"
      );

      console.log("Email sent successfully");

      // 2. PHP ke through DB me save karna
      const response = await fetch("https://workdayz.in/save_form.php", {
        method: "POST",
        body: JSON.stringify(jsonData),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      console.log("PHP Response:", result);

      if (result.success) {
        navigate("/thank-you");
      } else {
        alert("Database save failed: " + result.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <form ref={form} onSubmit={sendEmail}>
      <div className="row">
        <div className="col-sm-6">
          <input type="text" name="name" placeholder="Your Name" required />
        </div>
        <div className="col-sm-6">
          <input type="email" name="email" placeholder="Email Address" required />
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <input type="text" name="phone" placeholder="Phone Number" required />
        </div>
        <div className="col-sm-6">
          <input type="text" name="subject" placeholder="Subject" required />
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <textarea name="message" placeholder="Write Message" required></textarea>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <button type="submit" disabled={isSending}>
            {isSending ? "Sending..." : "Submit Now"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default ContactFormpage;
